export default function (state) {
    let data = [];
    let items = state.items;
    items.forEach(i => {
        let item = data.filter(j => {
            return j.paymentCurrencyName === i.PaymentCurrencyName;
        })[0];
        if (!item) data.push({
            paymentCurrencyName: i.PaymentCurrencyName,
            payed: i.Payed,
            needToPay: i.NeedToPay,
            paymentSum: i.PaymentSum
        });
        else {
            item.payed += i.Payed;
            item.needToPay += i.NeedToPay;
            item.paymentSum += i.PaymentSum;
        }
    });
    return data;
}